export default {"src":"/_next/static/image/public/images/ic_process.1e8f31ab0793e50b5d0b2daa33376b47.svg","height":53,"width":56};